// PROVEN WORKING: Always visible gift products WITH working cart + bundle removal
console.log('🎁 Loading Always Visible Gift Products...');

// IMPORTANT (Liquid tweak):
// In your cart item template, add data-line-key to the remove button so this JS can find the line key:
// <button class="cart-remove-button" type="button" name="remove" data-line-key="{{ item.key }}">Remove</button>

const SECOND_VARIANT_ID = '60685595476338';
const GIFT_PRODUCT_IDS = [60763878588786, 60763875475826, 60763878982002];

// Variant tracking
let currentVariantId = null;
setInterval(() => {
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput && variantInput.value !== currentVariantId) {
    currentVariantId = variantInput.value;
    updateGiftProductsUI(currentVariantId);
  }
}, 500);

// Update UI based on variant selection
function updateGiftProductsUI(variantId) {
  const giftBlock = document.querySelector('.gift-products-block');
  if (!giftBlock) return;

  const isActive = variantId === SECOND_VARIANT_ID;

  // Update subtitle text
  const subtitle = giftBlock.querySelector('.gift-products-subtitle');
  if (subtitle) {
    subtitle.innerHTML = isActive
      ? 'These items will be automatically added to your cart!'
      : 'Select the specific variant to unlock these free gifts!';
  }

  // Toggle images
  const defaultImages = giftBlock.querySelectorAll('.gift-product-default-image');
  const actualImages = giftBlock.querySelectorAll('.gift-product-actual-image');

  defaultImages.forEach((img) => {
    img.style.display = isActive ? 'none' : 'block';
  });

  actualImages.forEach((img) => {
    img.style.display = isActive ? 'block' : 'none';
  });

  // Add/remove active class for styling
  giftBlock.classList.toggle('gift-products-block--active', isActive);
}

// Get current selling plan from Appstle widget
function getCurrentSellingPlan() {
  const selectedPlan = document.querySelector('input[name="selling_plan"]:checked');
  return selectedPlan ? selectedPlan.value : '';
}

// Utility: get sections list like Dawn's cart.js expects
function getSectionsList(cartDrawerItems) {
  try {
    return cartDrawerItems.getSectionsToRender().map((section) => section.section);
  } catch (e) {
    return [];
  }
}

// Utility: re-render drawer sections from a parsed state (matches Dawn behavior)
function renderCartFromParsedState(parsedState) {
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  if (!cartDrawerItems) return;

  cartDrawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
  const cartDrawerWrapper = document.querySelector('cart-drawer');
  if (cartDrawerWrapper) {
    cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  if (cartDrawerItems.getSectionsToRender && parsedState.sections) {
    cartDrawerItems.getSectionsToRender().forEach((section) => {
      if (!parsedState.sections[section.section]) return;
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);
      if (elementToReplace && cartDrawerItems.getSectionInnerHTML) {
        elementToReplace.innerHTML = cartDrawerItems.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });
  }
}

// SIMPLIFIED: Only use direct form interception, don't hook into product-form
document.addEventListener(
  'submit',
  async function (e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    // ONLY handle the specific gift variant
    if (variantInput.value !== SECOND_VARIANT_ID) {
      // Let all other variants submit normally
      return;
    }

    if (window.giftProductsHandled) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    window.giftProductsHandled = true;

    const button = form.querySelector('button[type="submit"]');
    const originalText = button ? button.innerHTML : '';

    try {
      if (button) {
        button.innerHTML = 'Adding...';
        button.disabled = true;
      }

      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (!cartDrawerItems) {
        throw new Error('Cart drawer items not found');
      }

      // Get current selling plan from Appstle
      const sellingPlan = getCurrentSellingPlan();

      // --- 👇 NEW: create a shared bundle id for parent + gifts
      const bundleId = Math.random().toString(36).slice(2);

      // Add main product (parent)
      const mainProductData = {
        id: variantInput.value,
        quantity: 1,
        properties: { bundle_id: bundleId },
      };

      // Add selling plan if subscription is selected
      if (sellingPlan) {
        mainProductData.selling_plan = sellingPlan;
      }

      console.log('🛒 Adding main product:', mainProductData);
      await addItemToCart(cartDrawerItems, mainProductData);

      // Add gift products (ALWAYS ONE-TIME, no subscription)
      for (const giftId of GIFT_PRODUCT_IDS) {
        const giftProductData = {
          id: giftId.toString(),
          quantity: 1,
          properties: {
            _gift_product: 'true',
            is_gift: 'true',
            bundle_parent: bundleId, // link to parent
          },
        };

        console.log('🎁 Adding gift product:', giftProductData);
        await addItemToCart(cartDrawerItems, giftProductData);
      }

      console.log('✅ All products added successfully');

      // Auto-open cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        console.log('🚀 Opening cart drawer...');
        cartDrawer.open();
      }

      if (button) button.innerHTML = 'Added!';
    } catch (error) {
      console.error('❌ Error:', error);
      if (button) button.innerHTML = 'Error';

      // Fallback: submit the form normally
      setTimeout(() => {
        form.removeEventListener('submit', arguments.callee);
        form.submit();
      }, 2000);
    } finally {
      setTimeout(() => {
        if (button) {
          button.innerHTML = originalText;
          button.disabled = false;
        }
        window.giftProductsHandled = false;
      }, 3000);
    }
  },
  true
);

// PROVEN WORKING cart addition method - WITH ERROR FIX
async function addItemToCart(cartDrawerItems, itemData) {
  return new Promise((resolve, reject) => {
    const sections = getSectionsList(cartDrawerItems);

    const body = JSON.stringify({
      items: [
        {
          id: itemData.id,
          quantity: itemData.quantity,
          properties: itemData.properties || {},
          selling_plan: itemData.selling_plan || null,
        },
      ],
      sections,
      sections_url: window.location.pathname,
    });

    console.log('📤 Sending cart request:', body);

    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.log('📥 Cart response:', parsedState);

        if (parsedState.errors) {
          reject(new Error(parsedState.errors));
          return;
        }

        renderCartFromParsedState(parsedState);
        resolve(parsedState);
      })
      .catch((error) => {
        console.error('❌ Cart add error:', error);
        reject(error);
      });
  });
}

// --- NEW: Remove parent + linked gifts in one go
async function removeLineAndLinkedGifts(mainKey) {
  // 1) Load current cart
  const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

  const cartDrawerItems = document.querySelector('cart-drawer-items');
  const sections = getSectionsList(cartDrawerItems);

  // 2) Find the clicked line and determine if it's a bundle parent
  const mainLine = cart.items.find((i) => i.key === mainKey);
  if (!mainLine) {
    // if we can't find it, just remove it normally
    return removeSingleLine(mainKey, sections);
  }

  const bundleId = mainLine?.properties?.bundle_id;

  // If it's not a parent (no bundle_id), just remove this one line
  if (!bundleId) {
    return removeSingleLine(mainKey, sections);
  }

  // 3) Build updates to remove parent + all gifts with bundle_parent === bundleId
  const updates = {};
  updates[mainKey] = 0;

  cart.items.forEach((i) => {
    const p = i.properties || {};
    if (p.bundle_parent === bundleId) {
      updates[i.key] = 0;
    }
  });

  // 4) Submit update and re-render sections
  const body = JSON.stringify({
    updates,
    sections,
    sections_url: window.location.pathname,
  });

  return fetch(`${routes.cart_update_url}`, {
    ...fetchConfig(),
    ...{ body },
  })
    .then((r) => r.text())
    .then((state) => {
      const parsedState = JSON.parse(state);
      renderCartFromParsedState(parsedState);
    })
    .catch((err) => console.error('❌ Cart bundle update error:', err));
}

// Remove a single line (used for normal, non-parent removes)
async function removeSingleLine(key, sectionsOverride) {
  const sections =
    sectionsOverride ||
    (document.querySelector('cart-drawer-items') ? getSectionsList(document.querySelector('cart-drawer-items')) : []);

  const body = JSON.stringify({
    id: key,
    quantity: 0,
    sections,
    sections_url: window.location.pathname,
  });

  return fetch(`${routes.cart_change_url || '/cart/change.js'}`, {
    ...fetchConfig(),
    ...{ body },
  })
    .then((r) => r.text())
    .then((state) => {
      // cart/change.js returns JSON (AJAX) or section-render JSON depending on theme;
      // try to parse and render if sections provided
      try {
        const parsedState = JSON.parse(state);
        if (parsedState && parsedState.sections) {
          renderCartFromParsedState(parsedState);
        } else {
          // Fallback: hard refresh if theme doesn't return sections
          location.reload();
        }
      } catch {
        location.reload();
      }
    })
    .catch((err) => console.error('❌ Cart change error:', err));
}

// Intercept remove button clicks and do the smart removal
document.addEventListener(
  'click',
  (e) => {
    const btn = e.target.closest(
      '[data-cart-remove], [data-remove], .cart__remove, button[name="remove"], .cart-remove-button'
    );
    if (!btn) return;

    const key = btn.getAttribute('data-line-key') || btn.dataset.lineKey || btn.dataset.key;
    if (!key) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    removeLineAndLinkedGifts(key);
  },
  true
);

// Initialize
document.addEventListener('DOMContentLoaded', function () {
  // Add CSS for the always-visible gift products
  const style = document.createElement('style');
  style.textContent = `
    .gift-products-block {
      margin: 1rem 0;
      padding: 0;
    }
    .cart-item--product-birriabomb dl div:nth-child(2){
     display: none !important;
    }
     .cart-item--product-birria-recipe-book .product-option{
     display: none !important;
    }
     .cart-item--product-tasty-bombs-fridge-magnet .product-option{
     display: none !important;
    }
     .cart-item--product-trip-to-los-cabos-mexico-raffle .product-option{
     display: none !important;
    }
    .gift-products-header {
      text-align: center;
      margin-bottom: 2rem;
    }

    .gift-products-subtitle {
      margin: 0;
      color: #666;
      font-size: 0.9rem;
    }

    .gift-products-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr) !important;
      gap: 1rem;
      margin-top: 1rem;
    }

    .gift-product-item {
      text-align: center;
      padding: 0.5rem;
      position: relative;
    }

    .gift-product-image {
      width: 80px;
      height: 80px;
      margin: 0 auto 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #eff0f2;
      border-radius: 8px;
      border: 1px solid #eff0f2;
    }

    .gift-product-info {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }

    .gift-product-title {
      font-size: 12px;
      font-weight: 700;
      color: #000;
    }

    .gift-product-price {
      font-size: 1.2rem;
      background: #ff6f00;
      color: white;
      padding: 0px 7px;
      border-radius: 50px;
      font-weight: bold;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `;
  document.head.appendChild(style);

  // Initialize with current variant
  setTimeout(() => {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      currentVariantId = variantInput.value;
      updateGiftProductsUI(currentVariantId);
    }
  }, 1000);
});